<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HeaderLogin',
  props: {
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
  },
});
</script>

<template>
  <header class="flex flex-col pt-20 p-10 items-center text-white z-20">
    <h1 class="font-normal text-2xl">{{ title }}</h1>
    <h2 class="font-bold text-lg">{{ subTitle }}</h2>
  </header>
</template>
